import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, Stack, FormTextField, FormActions } from "sprint-common-web";

import { TvSeriesListingItem } from "../TvSeriesListingItem";
import { AddTvSeriesFormInputs } from "./CreateTvSeriesFormInputs";
import { useCreateTvSeriesForm } from "./useCreateTvSeriesForm";

export interface CreateTvSeriesFormProps {
    onCancel(): void;
    onSubmit(newTvSeries: TvSeriesListingItem): void;
}

export const CreateTvSeriesForm: React.FunctionComponent<CreateTvSeriesFormProps> = (
    props: CreateTvSeriesFormProps
) => {
    const { errors, control, formState, handleSubmit } = useForm<AddTvSeriesFormInputs>({
        defaultValues: {
            title: ""
        },
        criteriaMode: "all"
    });

    const { createNewTvSeries, validateTitle } = useCreateTvSeriesForm();

    const createTvSeries = async (inputs: AddTvSeriesFormInputs) => {
        const newItem = await createNewTvSeries(inputs);
        props.onSubmit(newItem);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(createTvSeries)}>
            <FormFields>
                <Stack>
                    <FormTextField
                        label="Title"
                        control={control}
                        name="title"
                        errors={errors}
                        rules={{ required: "Enter correct title", validate: validateTitle }}
                    />
                </Stack>
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancel} />
        </Form>
    );
};
